import { groq } from '#imports';

export function getQuery({ slug, isDraft = false, previewId } = {}) {
  if (isDraft) {
    return groq`*[_type == "news" && slug.current == "${slug}" && uuid == "${previewId}"] | order(_updatedAt desc)[0]{
      ...,
      'uuid': false,
      seoTitle,
      seoDescription,
      tags[]->{..., tag->},
      content[]{
      _type != 'recommendedArticle' && _type != 'recommendedNewsItem' && _type != 'authorOpinion' => @,
      _type == 'recommendedArticle' => {..., article-> {
         _type,
          slug,
          image,
          publishedAt,
          size,
          title,
          subtitle,
          titleColor,
          subtitleColor,
          shadowColor,
          isFullImage,
          backgroundColor[]{hex->},
          crew[]{staff->, speciality->},
         }
        },
        _type == 'recommendedNewsItem' => {..., newsItem-> {
         _type,
          slug,
          publishedAt,
          title,
          titleColor,
          backgroundColor[]{hex->},
         }
        },
        _type == 'authorOpinion' => {..., author->}
      }
    }`;
  }

  return groq`*[_type == "news" && slug.current == "${slug}" && !(_id in path('drafts.**'))][0]{
    ...,
    'uuid': false,
    seoTitle,
    seoDescription,
    tags[]->{..., tag->},
    content[]{
      _type != 'recommendedArticle' && _type != 'recommendedNewsItem' && _type != 'authorOpinion' => @,
      _type == 'recommendedArticle' => {..., article-> {
         _type,
          slug,
          image,
          publishedAt,
          size,
          title,
          subtitle,
          titleColor,
          subtitleColor,
          shadowColor,
          isFullImage,
          backgroundColor[]{hex->},
          crew[]{staff->, speciality->},
         }
        },
        _type == 'recommendedNewsItem' => {..., newsItem-> {
         _type,
          slug,
          publishedAt,
          title,
          titleColor,
          backgroundColor[]{hex->},
         }
        },
        _type == 'authorOpinion' => {..., author->}
      }
  }`;
}
